import {useDispatch} from "react-redux";
import {showSidebar} from "../../../store/actions/sidebar";

const TopbarButton = () => {
    const dispatch = useDispatch();
    const handleClick = () => {
        document.body.classList.add('aux-navigation-active');
        document.body.classList.add('no-scroll');
        dispatch(showSidebar());
    };

    return (
        <li className="aux-navigation hide">
            <a className="navigation-show side-nav-show nav-icon" onClick={() => handleClick()}>
                <span className="icon-menu"></span>
            </a>
        </li>
    )
}

export default TopbarButton;